import { render } from "./weather.vue?vue&type=template&id=5dc601c4&scoped=true"
import script from "./weather.vue?vue&type=script&lang=js"
export * from "./weather.vue?vue&type=script&lang=js"

import "./weather.vue?vue&type=style&index=0&id=5dc601c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5dc601c4"

export default script